import "../CSS/itemUsuario.css";
import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
function ItemPagoDiferido(props) {
  const [sexo, setSexo] = useState("trabajador");
  const [montoPago, setMontoPago] = useState(props.monto);

  useEffect(() => {
	
  }, []);
  const handleOnChangeMonto = (event) => {
    setMontoPago(event.target.value);
    //esNumero(event.target.value);
  };
  return (
    <div className="user-card">
      <div className="user-infocard">
        <img
          id="imagenTienda"
          className="user-icon"
          src={require(`../img/credit-card.png`)}
          alt="flecha"
        />
        <div className="user-info">
          <div>
            <h5 className="user-nombre">{props.nombre}</h5>
            <small>{props.codigo}</small>
          </div>
          <Box sx={{ width: 100 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                marginLeft: "30px",
              }}
            >
              <TextField
                sx={{ width: 350 }}
                label="Monto"
                variant="standard"
                value={montoPago}
				onChange={handleOnChangeMonto}

              />
            </Box>
          </Box>
        </div>

        <img
          id="imagenTienda"
          className="user-icon"
          src={require(`../img/editar.png`)}
          alt="flecha"
		  onClick={() => props.editarUsuario(props.id,props.nombre,props.codigo,montoPago)}

        />

        <img
          className="user-icon"
          src={require(`../img/borrar.png`)}
          alt="borrar"
          onClick={() => props.deleteUsuario(props.id)}
        />
      </div>
    </div>
  );
}

export default ItemPagoDiferido;
